import { Dialog, Transition } from "@headlessui/react"
import React, { Fragment } from "react"

interface IProps {
    isOpen: boolean,
    children: any
}

export default function Modal(props: IProps) {
    const {isOpen, children} = props
    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 h-full w-full"
                    onClose={() => {
                        //
                    }}
                >
                    <div className="w-full h-full flex flex-col items-center justify-center relative">
                        <Transition.Child>
                            <div className={"absolute inset-0 bg-black opacity-60"} />
                        </Transition.Child>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >

                            <div className={"w-full h-full flex flex-col items-center justify-center"}>
                                {children}
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
